const getUTCTimeObject = (date) => {
  return {
    /**
     * Число 24 необходимо для случая, когда ДЦ работает до 00:00
     * Без этого, сравнивая текущее время с временем закрытия,
     * мы всегда будем получать "закрыто".
     */
    hours: date.getUTCHours() === 0 ? 24 : date.getUTCHours(),
    minutes: date.getUTCMinutes(),
    seconds: date.getUTCSeconds()
  };
};
export {
  getUTCTimeObject
};
